export interface RepairCode {
  code: string;
  desc: string;
}
